import { useEffect, useRef, useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Debe coincidir con la duración de la animación de salida de abajo.
const EXIT_MS = 240;

export function PwaUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });
  const [isLeaving, setIsLeaving] = useState(false);
  const exitTimerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (exitTimerRef.current !== null) window.clearTimeout(exitTimerRef.current);
    };
  }, []);

  // El aviso se desmonta DESPUÉS de la animación; si desapareciera de golpe
  // desentonaría con los toasts, que sí entran y salen.
  const handleDismiss = () => {
    setIsLeaving(true);
    exitTimerRef.current = window.setTimeout(() => {
      setNeedRefresh(false);
      setIsLeaving(false);
    }, EXIT_MS);
  };

  if (!needRefresh) return null;

  return (
    <div
      role="status"
      className={cn(
        // Misma esquina que el aviso de instalacion: los flotantes de la app
        // viven abajo a la derecha en escritorio y sobre la barra en el movil.
        "fixed inset-x-3 bottom-[calc(5.5rem+env(safe-area-inset-bottom))] z-toast flex max-w-md items-center gap-3 rounded-xl border border-border bg-card p-3 shadow-xl md:bottom-5 md:left-auto md:right-5 md:w-96",
        isLeaving
          ? "animate-out fade-out-0 slide-out-to-bottom-2 fill-mode-forwards duration-moderate ease-smooth"
          : "animate-fade-in-up"
      )}
    >
      <RefreshCw className="h-5 w-5 shrink-0 text-primary" />
      <p className="min-w-0 flex-1 text-sm text-foreground">
        Hay una nueva versión de Agricos lista.
      </p>
      <Button size="sm" onClick={() => void updateServiceWorker(true)}>
        Actualizar
      </Button>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Cerrar aviso de actualización"
        onClick={handleDismiss}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
